import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import colunms from "../../../Components/assets/icons/LINES.png";
import search1 from "../../../Components/assets/icons/search.png";
import top from "../../../Components/assets/icons/top.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast, { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import ModelBulkUpload from "../../common/ModelBulkUpload";
import { AddButton, EditButton, DeletButton } from "../../common/Button";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import OffcanvasCon from "../../OffcanvasCon/OffcanvasCon";
import DataTable from "datatables.net";
import { IDS, RoleId } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Pagination from "react-bootstrap/Pagination";
import Select from "react-select";
import dayjs from "dayjs";

library.add(fas);

const Tables = () => {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    Per_Page_Dropdown,
    postData,
    getDownloadDataExcel,
    isAllow,
    IMG_URL,
  } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [showSubscribe, setShowSubscribe] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [showoff, setShowoff] = useState(false);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  const [type, setType] = useState();
  const today = new Date().toISOString().split("T")[0]; // Format today as YYYY-MM-DD
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errors, setErrors] = useState({});

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    validateDates(e.target.value, endDate);
  };

  // Handle End Date change
  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    validateDates(startDate, e.target.value);
  };

  // Validate Dates
  const validateDates = (start, end) => {
    let newErrors = {};
    const startDateObj = new Date(start);
    const endDateObj = new Date(end);

    // Validate Start Date
    if (start && startDateObj > new Date(today)) {
      newErrors.startDate = "Start date must be today or in the past";
    }

    // Validate End Date
    // if (end && endDateObj <= startDateObj) {
    //   newErrors.endDate = "End date must be greater than start date";
    // }

    setErrors(newErrors);
  };
  const [loading, setLoading] = useState(false);

  const getDataAll = async () => {
    setLoading(true);

    const response = await getData(
      `/admin/wallet?page=${onPageChange}&per_page=${perPage || 10}&term=${search || ""}&type=${type?.value || ""}&startDate=${startDate}&endDate=${endDate}`,
    );
    await setData(response);

    if (response?.success) {
      setLoading(false);
    }
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page || 10);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);

    setOption(await Per_Page_Dropdown(response?.data?.total));
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const ChangeStatus = async (id) => {
    const response = await editStatusData(`/admin/wallet/${id}`);
    setChangeStatus(response);
  };

  // Modal function
  const handleClose = () => setShowAdd(false);
  const handleShow = () => setShowAdd(true);

  const handleClose1 = () => setShowEdit(0);
  const handleShow1 = (id) => {
    setShowEdit(id);
  };

  // Delete module
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = async (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/admin/wallet/${recordToDeleteId}`);
      // notify("error", "Deleted Succefully");

      ErrorNotify(recordToDeleteName);

      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  //  column hide and show.....
  const [visible, setVisibel] = useState({
    col0: true,
    col1: true,
    col2: true,
    col3: true,
    col4: true,
    col5: true,
    col6: true,
  });

  //toggle columnns.........
  const toggleColumn = (event, columnName) => {
    event.preventDefault();
    setVisibel((prev) => ({
      ...prev,
      [columnName]: !prev[columnName],
    }));
  };

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  useEffect(() => {
    const table = new DataTable("#example");
    return () => {
      table.destroy();
    };
  }, []);

  const [user, setUser] = useState({});
  const GetUser = async () => {
    const response = await getData(`/common/auth/usersingleget`);
    if (response?.success) {
      setUser(response?.data);
    }
  };
  useEffect(() => {
    GetUser();
  }, []);

  const roleOptions = [
    { label: "All", value: "" },
    { label: "Credit", value: "credit" },
    { label: "Debit", value: "debit" },
  ];

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        const fileName = `Wallet_History_${dayjs().format("DDMMMYYYY").toLowerCase()}`;

        await getDownloadDataExcel(
          `/admin/wallet/download?term=${search || ""}&type=${type?.value || ""}&startDate=${startDate}&endDate=${endDate}`,
          null,
          fileName,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };
  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Wallet History"} link={"/admin/wallet"} />
        <section className="AdvanceDashboard">
          <section className="Tabels tab-radio tab-radio mt-3">
            <div className="">
              {/* container */}
              <div className="row p-2">
                {/* <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="border-line mt-3" />
                     

                      <div className="package-details-section-top-heading">
                        <div className="pending-table ">
                          <div className="d-flex  align-items-center">
                           

                            <div className="text-center  ms-5">
                              <Button onClick={() => setShowEdit(1)}>
                                + Add Money
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                <div className="border-line mt-3"></div>

                <div className="row mt-4">
                  <div className=" col-12">
                    <div className="">
                      <div className=" top-showing-wrapper sowing ms-3 me-2">
                        <p className="show m-0">Show</p>
                        <select
                          className="form-select form-select-sm"
                          aria-label=".form-select-sm example"
                          onChange={(e) => {
                            setonPageChange(1);
                            setperPage(e.target.value);
                          }}
                        >
                          {option?.map((option) => (
                            <option key={option} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        <p className="show m-0">
                          {" "}
                          entries{" "}
                          {`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1,
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.total,
                          )} of ${data?.data?.total} entries`}
                        </p>
                      </div>
                    </div>
                    {/* </div>
                        <div className="   col-12"> */}
                    <div className="row align-items-end">
                      <div
                        className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        <Form.Label>User Uid / Name</Form.Label>
                        <div className="num">
                          <Form.Control
                            type="text"
                            placeholder="User Uid / Name"
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                            }}
                            isInvalid={!!errors.startDate}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.startDate}
                          </Form.Control.Feedback>
                        </div>
                      </div>
                      <div
                        className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        <Form.Label>Type</Form.Label>
                        <div className="num">
                          <Select
                            options={roleOptions}
                            value={type}
                            defaultValue={roleOptions[0] || []}
                            onChange={(e) => setType(e)}
                            placeholder="Type"
                          />
                        </div>
                      </div>
                      <div
                        className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 mb-2"
                        style={{ fontSize: "14px" }}
                      >
                        <Form.Label>Start Date</Form.Label>
                        <div className="num">
                          <Form.Control
                            type="date"
                            isInvalid={!!errors.startDate}
                            min="0001-01-01"
                            max="9999-12-31"
                            className="form-control"
                            placeholder="Start Date"
                            value={startDate}
                            onChange={(e) => {
                              setStartDate(e.target.value);
                              setEndDate("");
                              setonPageChange(1);
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.startDate}
                          </Form.Control.Feedback>
                        </div>
                      </div>

                      {/* End Date */}
                      <div
                        className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 mb-2 head-label-title"
                        style={{ fontSize: "14px" }}
                      >
                        <Form.Label>End Date</Form.Label>
                        <div className="num">
                          <Form.Control
                            type="date"
                            isInvalid={!!errors.endDate}
                            className="form-control"
                            min={startDate ? startDate : "0001-01-01"}
                            max="9999-12-31"
                            placeholder="to"
                            value={endDate}
                            onChange={(e) => {
                              setEndDate(e.target.value);
                              setonPageChange(1);
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.endDate}
                          </Form.Control.Feedback>
                        </div>
                      </div>

                      <div className="col-xxl-3 col-xl-3  col-lg-4  col-md-4 col-sm-6 mb-2 d-flex gap-3 align-items-end">
                        <div className="Search me-2">
                          <Button
                            type="button"
                            onClick={() => {
                              setonPageChange(1);
                              getDataAll();
                            }}
                            className="btn btn-search"
                          >
                            Search
                          </Button>
                        </div>
                        <div className="Search-1">
                          <button
                            type="button"
                            onClick={() => {
                              setSearch("");
                              setStartDate("");
                              setEndDate("");
                              setType(roleOptions[0]);
                              setReset(!reset);
                            }}
                            className="btn btn-reset"
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                      <div
                        className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-6 mb-2 "
                        style={{ fontSize: "13px" }}
                      >
                        <div>
                          <button
                            className="btn btn-success "
                            type="button"
                            onClick={HandleDownload}
                          >
                            Download Excel
                            <FontAwesomeIcon
                              icon="fa-solid fa-file-lines"
                              className="ms-2"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-line mt-3"></div>
              <div className="row mt-3 p-1">
                <div className="data table-responsive">
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr className="">
                        {visible.col1 && (
                          <th className="sr" style={{ width: "4%" }}>
                            Sr. No.
                          </th>
                        )}
                        {visible.col2 && (
                          <th className="tax-name" style={{ width: "6%" }}>
                            Date Time
                          </th>
                        )}
                        {visible.col3 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Customer
                          </th>
                        )}
                        {visible.col3 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Amount
                          </th>
                        )}
                        {visible.col4 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Type
                          </th>
                        )}
                        {visible.col5 && (
                          <th className="tax-name" style={{ width: "10%" }}>
                            Transaction ID
                          </th>
                        )}
                        {visible.col6 && (
                          <th className="tax-name" style={{ width: "20%" }}>
                            Description
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        data?.data?.data?.map((d, index) => {
                          const paginatedIndex =
                            (onPageChange - 1) * perPage + index + 1;
                          return (
                            <tr className="" key={index}>
                              {visible.col1 && <td>{paginatedIndex}.</td>}
                              {visible.col2 && (
                                <td>
                                  {new Date(d?.createdAt).toLocaleString(
                                    "en-IN",
                                    {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      second: "2-digit",
                                      hour12: false,
                                    },
                                  )}
                                </td>
                              )}
                              {visible.col3 && (
                                <td>
                                  {d?.Wallet?.User?.name || "-"} (
                                  {d?.Wallet?.User?.user_uid || "-"})
                                </td>
                              )}
                              {visible.col3 && <td>₹ {d?.amount}</td>}
                              {visible.col4 && (
                                <td
                                  style={{
                                    color:
                                      d?.transaction_type === "debit"
                                        ? "red"
                                        : "green",
                                  }}
                                >
                                  {d?.transaction_type}
                                </td>
                              )}
                              {visible.col5 && (
                                <td>{d?.transaction_id || "_"}</td>
                              )}
                              {visible.col6 && <td>{d?.description}</td>}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </Table>
                  {data && data?.data?.data?.length > 0 ? (
                    <Pagination_Holder
                      onPageChange={currentPage}
                      totalPages={totalPages}
                      handlePageChange={handlePageChange}
                    />
                  ) : (
                    <p className="no-datashow">Sorry, No Data Found</p>
                  )}
                </div>
              </div>
            </div>
          </section>
        </section>
      </div>

      {show ? (
        <AddOffCanvance
          handleClose={handleClose}
          setShow={setShowAdd}
          show={show}
        />
      ) : (
        ""
      )}

      {show1 ? (
        <EditOffCanvance
          handleClose={handleClose1}
          setShow={setShowEdit}
          show={show1}
        />
      ) : (
        ""
      )}

      <ModalDelete
        show={showDeleteModal}
        handleDeleteRecord={handleDeleteRecord}
        handleDeleteCancel={handleDeleteCancel}
      />

      <ModelBulkUpload
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
      <Toaster position="top-right" />

      <OffcanvasCon show={showoff} handleClose={() => setShowoff(false)} />
    </>
  );
};

export default Tables;
